import React from 'react';
import StepsHome from '../components/home/StepsHome';
import SustainibilityHome from '../components/home/SustainibilityHome';
import TeamHome from '../components/home/TeamHome';
import BimHome from '../components/home/BimHome';
import HomeCarouselSimple from '../components/home/HomeCarouselSimple.jsx';
import Statistics from '../components/home/Statistics';
import { useTranslation } from 'react-i18next';
import Seo from '../components/seo/Seo';

const Home = () => {
  const { t } = useTranslation('home');
  const title = `Betonoki - ${t('project studio')}`;
  const description =
    t('metaDescription', {
      defaultValue: 'Betonoki – biuro projektowe. Projektowanie, BIM i nowoczesne rozwiązania dla inwestycji.',
    });
  return (
    <>
      <Seo title={title} description={description} path="/" />
      <HomeCarouselSimple/>
      <Statistics />
      {/* <AboutHome/> */}
      <StepsHome />
      <BimHome />
      <SustainibilityHome/>
      <TeamHome />  
    </>
  );
};

export default Home;
